import TopBar from '@/pages/home/components/TopBar';
import Hero from '@/pages/home/components/Hero';
import TopicWall from '@/pages/home/components/TopicWall';
import BlacklistBoard from '@/pages/home/components/BlacklistBoard';
import CharacterFiles from '@/pages/home/components/CharacterFiles';
import UnfollowFeed from '@/pages/home/components/UnfollowFeed';
import RadarGuide from '@/pages/home/components/RadarGuide';
import JoinPanel from '@/pages/home/components/JoinPanel';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <TopBar />
      <main>
        <Hero />
        <TopicWall />
        <BlacklistBoard />
        <CharacterFiles />
        <UnfollowFeed />
        <RadarGuide />
        <JoinPanel />
      </main>
      <SiteFooter />
    </div>
  );
}